module.exports = __webpack_public_path__ + "img/gauze-open.48b5eed6.svg";